import gsap from 'gsap'
import { forEach } from 'lodash'

import { batchRevealAnimation } from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const defaultGridRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const filters = selector('[data-motion-filter]')
  const posts = selector('[data-motion-post]')

  let filtersBatchAnimation: ScrollTrigger[]
  if (filters.length > 0) {
    filtersBatchAnimation = batchRevealAnimation({
      targets: filters,
      reverse,
      delay,
      stagger: {
        amount: 0.12
      }
    })
  }

  let postsBatchAnimation: ScrollTrigger[]
  if (posts.length > 0) {
    postsBatchAnimation = batchRevealAnimation({
      targets: posts,
      reverse,
      delay,
      stagger: {
        amount: 0.12
      }
    })
  }

  return () => {
    forEach(filtersBatchAnimation || [], (animation) => animation.kill())
    forEach(postsBatchAnimation || [], (animation) => animation.kill())
  }
}
